import { ContainerModule, interfaces } from 'inversify';
import { IProjectsStore, ProjectsStore } from './projects.store';
import { IProjectsApiService, ProjectsApiService } from './services/projectApi.service';

export const projectsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IProjectsStore.$).to(ProjectsStore).inSingletonScope();
  bind(IProjectsApiService.$).to(ProjectsApiService).inSingletonScope();
});
